import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../css/trending.css"; // Import the CSS file

const TrendingCarousel = () => {
  const [trendingCoins, setTrendingCoins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const fetchTrendingCoins = async () => {
      try {
        setLoading(true);
        const response = await fetch("https://api.coingecko.com/api/v3/search/trending");
        const data = await response.json();
        setTrendingCoins(data.coins || []);
      } catch (error) {
        console.error("Error fetching trending coins:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingCoins();
  }, []);

  useEffect(() => {
    if (trendingCoins.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % trendingCoins.length);
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, [trendingCoins]);

  return (
    <div className="trending-carousel">
      {loading ? (
        <div className="loading">Loading...</div>
      ) : trendingCoins.length === 0 ? (
        <div className="no-data">No trending coins available</div>
      ) : (
        <AnimatePresence mode="wait">
          <motion.a
            key={trendingCoins[index]?.item?.id}
            href={`https://www.coingecko.com/en/coins/${trendingCoins[index]?.item?.id}`}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.5 }}
            className="trending-coin"
          >
            <span className="trending-coin-rank">#{index + 1}</span>
            <img
              src={trendingCoins[index]?.item?.thumb}
              alt={trendingCoins[index]?.item?.name}
            />
            <span className="trending-coin-name">{trendingCoins[index]?.item?.name}</span>
            <span
              className={`trending-coin-change ${
                trendingCoins[index]?.item?.data?.price_change_percentage_24h?.usd > 0
                  ? "positive"
                  : "negative"
              }`}
            >
              {trendingCoins[index]?.item?.data?.price_change_percentage_24h?.usd?.toFixed(2)}%
            </span>
          </motion.a>
        </AnimatePresence>
      )}
    </div>
  );
};

export default TrendingCarousel;
